/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Benefit_SocialInputs */

const en_directory_promotion_benefit_social = /** @type {(inputs: Directory_Promotion_Benefit_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsor includes social promotion by the Seek AI team.`)
};

const zh_directory_promotion_benefit_social = /** @type {(inputs: Directory_Promotion_Benefit_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsor 套餐包含 Seek AI 团队的社交媒体推广。`)
};

/**
* | output |
* | --- |
* | "Sponsor includes social promotion by the Seek AI team." |
*
* @param {Directory_Promotion_Benefit_SocialInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_benefit_social = /** @type {((inputs?: Directory_Promotion_Benefit_SocialInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Benefit_SocialInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_benefit_social(inputs)
	return zh_directory_promotion_benefit_social(inputs)
});
export { directory_promotion_benefit_social as "directory.promotion.benefit_social" }